import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HeaderComponent } from './header-general/header/header.component';
import { ReportesChatsComponent } from './reportes-chats/reportes-chats.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ReportesProductividadAgentesComponent } from './reportes-productividad-agentes/reportes-productividad-agentes.component';
import { MomentModule } from 'angular2-moment';
import { ReportesChatsBotComponent } from './reportes-chats-bot/reportes-chats-bot.component';
import { AddPlantillasComponent } from './add-plantillas/add-plantillas.component';
import { ViewPlantillasComponent } from './view-plantillas/view-plantillas.component';
import { ReportePlantillasComponent } from './reporte-plantillas/reporte-plantillas.component';
import { PipesModule } from '../pipes/filtroAgente/pipes.module';
import { ReporteEncuestasComponent } from './reporte-encuestas/reporte-encuestas.component';
import { MenuPopoverComponent } from './header-general/menu-popover/menu-popover.component';
import { HeaderMasivosComponent } from './header-masivos-component/header-masivos/header-masivos.component';
import { MenuMasivosPopoverComponent } from './header-masivos-component/menu-masivos-popover/menu-masivos-popover.component';
import { ReporteRegistroInicioSesionComponent } from './reporte-registro-inicio-sesion/reporte-registro-inicio-sesion.component';
import { InterfazInformacionComponent } from './interfaz-informacion/interfaz-informacion.component';
import { FotoPerfilComponent } from './foto-perfil/foto-perfil.component';
import { PerfilPopoverComponent } from './perfil-popover/perfil-popover.component';
import { GeneralPopoverComponent } from './header-general/general-popover/general-popover.component';
import { MasivosPopoverComponent } from './header-masivos-component/masivos-popover/masivos-popover.component';
import { PlantillasPopoverComponent } from './plantillas-popover/plantillas-popover.component';
import { VerPlantillaComponent } from './ver-plantilla/ver-plantilla.component';
import { TipificacionPopoverComponent } from './tipificacion-popover/tipificacion-popover.component';
import { LocalidadPopoverComponent } from './localidad-popover/localidad-popover.component';
import { MunicipioPopoverComponent } from './municipio-popover/municipio-popover.component';
import { EstadoPopoverComponent } from './estado-popover/estado-popover.component';
import { CodigoPaisPopoverComponent } from './codigo-pais-popover/codigo-pais-popover.component';
import { SearchListComponent } from './search-list/search-list.component';
import { NotifyPopoverComponent } from './notify-popover/notify-popover.component';
import { PopoverDescriptionComponent } from './popover-description/popover-description.component';
import { WidgetComponent } from './widget/widget.component';
import { OptUsuariosComponent } from './opt-usuarios/opt-usuarios.component';


@NgModule({
  declarations: [
    GeneralPopoverComponent,
    HeaderComponent,
    HeaderMasivosComponent,
    MasivosPopoverComponent,
    MenuPopoverComponent,
    MenuMasivosPopoverComponent,
    ReportesChatsComponent,
    ReportesProductividadAgentesComponent,
    ReportesChatsBotComponent,
    AddPlantillasComponent,
    ViewPlantillasComponent,
    ReportePlantillasComponent,
    ReporteEncuestasComponent,
    ReporteRegistroInicioSesionComponent,
    InterfazInformacionComponent,
    FotoPerfilComponent,
    PerfilPopoverComponent,
    PlantillasPopoverComponent,
    VerPlantillaComponent,
    TipificacionPopoverComponent,
    LocalidadPopoverComponent,
    MunicipioPopoverComponent,
    EstadoPopoverComponent,
    CodigoPaisPopoverComponent,
    SearchListComponent,
    NotifyPopoverComponent,
    PopoverDescriptionComponent,
    WidgetComponent,
    OptUsuariosComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    MomentModule,
    PipesModule
  ],
  exports: [
    GeneralPopoverComponent,
    HeaderComponent,
    MasivosPopoverComponent,
    HeaderMasivosComponent,
    ReportesChatsComponent,
    ReportesProductividadAgentesComponent,
    ReportesChatsBotComponent,
    AddPlantillasComponent,
    ViewPlantillasComponent,
    ReportePlantillasComponent,
    ReporteEncuestasComponent,
    ReporteRegistroInicioSesionComponent,
    InterfazInformacionComponent,
    FotoPerfilComponent,
    PerfilPopoverComponent,
    PlantillasPopoverComponent,
    VerPlantillaComponent,
    TipificacionPopoverComponent,
    LocalidadPopoverComponent,
    MunicipioPopoverComponent,
    EstadoPopoverComponent,
    CodigoPaisPopoverComponent,
    SearchListComponent,
    NotifyPopoverComponent,
    PopoverDescriptionComponent,
    WidgetComponent,
    OptUsuariosComponent
  ],
  providers: [
    DatePipe
  ]
})
export class ComponentsModule { }
